import { HttpInstance } from "lib/HttpLib";

export const getVeiwInfo = (param) => {
  return HttpInstance.get(process.env.REACT_APP_USER_SERVER + "/change/branch_view", {
    params: {
      member_id: param.member_id === null ? "" : param.member_id,
    },
  });
};

const get_api = {
  getVeiwInfo,
};

export default get_api;
